export default __webpack_public_path__ + "static/media/CarGo_Homepage_Flash_02_RHS.2e883f9e.png";